import React, { useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

import Navbar from "./components/Navbar";

import Home from "./pages/home";
import Result from "./pages/Result";
import Main from "./pages/main";
import About from "./pages/About";
import CLI from "./pages/CLI";
import Contact from "./pages/Contact";
import Database from "./pages/Database";
import OtherResources from "./pages/OtherResources";
import Processing from "./pages/Processing";
import License from "./pages/License";

import { Toaster } from "react-hot-toast";

function AppContent() {
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  const hideNavbar = location.pathname === "/search" && loading === true;

  return (
    <>
      {!hideNavbar && <Navbar />}

      <Toaster position="top-right" reverseOrder={false} />

      <Routes>
        <Route
          path="/search"
          element={<Home loading={loading} setLoading={setLoading} />}
        />
        <Route path="/" element={<Main />} />
        <Route path="/processing/:jobId" element={<Processing />} />
        <Route path="/result" element={<Result />} />
        <Route path="/database" element={<Database />} />
        <Route path="/cli" element={<CLI />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/license" element={<License />} />
        <Route path="/other-resources" element={<OtherResources />} />
      </Routes>
    </>
  );
}

export default function App() {
  return (
    <Router basename="/sharmaglab/origenomi">
      <AppContent />
    </Router>
  );
}
